// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2333":"68120821","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"2333":"bdab06513dd80882","5279":"053d2c45a48a2603","6743":"b8529c1f8de3bc1d","7229":"df29fcecd194ea25"}[chunkId] + ".js";
};